<template>
  <PopoverMenu
    v-if="text"
    :position="position"
    :has-arrow="true"
    :is-hover="true"
    :append-to-body="true"
  >
    <template #toggle-button>
      <slot />
    </template>
    <template #popover-content>
      <div name="body-regular-default">
        {{ text }}
      </div>
    </template>
  </PopoverMenu>
  <slot v-else />
</template>

<script setup lang="ts">
import { PopoverMenu } from '@lw-design-system/ui';

defineProps({
  text: {
    type: String,
    default: undefined
  },
  position: {
    type: String,
    default: 'top-center'
  }
});
</script>
